import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import FeatherIcon from 'feather-icons-react';
import UserEditModal from 'pages/users/UserEditModal';
import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export const UsersTableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'userName',
    header: 'Username',
    cell: ({ row: { original } }) => {
      const { userName } = original;
      const type = 'info';
      return (
        <div className="d-flex align-items-center">
          <div>
            <Link to="javascript:void(0)" className="fs-8 fw-bold">
              {userName}
            </Link>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: '15%', minWidth: '180px' },
        className: 'ps-4 pe-5 border-start border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-start border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'userId',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>UserId</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { userId } = original;
      return <>{userId}</>;
    },
    meta: {
      headerProps: {
        style: { width: '25%', minWidth: '180px' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'subscribeEmailId',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-success-subtle rounded me-2">
            <FeatherIcon icon="mail" size={16} className="text-success-dark" />
          </div>
          <span>Subscribe Email</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { subscribeEmailId } = original;
      return <>{subscribeEmailId}</>;
    },
    meta: {
      headerProps: {
        style: { width: '25%', minWidth: '180px' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'createdAt',
    header: 'Create date',
    cell: ({ row: { original } }) => original.createdAt,
    meta: {
      headerProps: {
        style: { width: '15%' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap ps-4 text-body-tertiary border-end border-translucent'
      }
    }
  },
  {
    id: 'actions',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Actions</span>
        </div>
      );
    },
    cell: ({ row: { original }, table }: any) => {
      const nav = useNavigate();
      const { getList } = table.options.meta;
      const [show, setShow] = useState(false);
      const [showEditModal, setShowEditModal] = useState(false);

      const handleClose = () => setShow(false);

      const handleCloseEditModal = () => {
        setShowEditModal(false);
        getList();
      };

      const handleShow = () => setShow(true);
      const handleShowEditModal = () => setShowEditModal(true);

      return (
        <>
          <RevealDropdownTrigger>
            <RevealDropdown>
              {/* <Dropdown.Item onClick={() => setShowEditModal(true)}>
                Edit
              </Dropdown.Item> */}
              <Dropdown.Item
                onClick={() => nav(`/users/${original.id}/details`)}
              >
                View
              </Dropdown.Item>

              <Dropdown.Item
                onClick={() =>
                  nav(`/normal-points-reward?userId=${original.id}`)
                }
              >
                Normal Points Transaction
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() =>
                  nav(`/referral-points-reward?userId=${original.id}`)
                }
              >
                Referral Points Transaction
              </Dropdown.Item>
            </RevealDropdown>
          </RevealDropdownTrigger>

          <UserEditModal
            show={showEditModal}
            onHide={() => setShowEditModal(false)}
            user={original}
            onSuccess={getList}
          />
        </>
      );
    },
    meta: {
      headerProps: {
        style: { width: '10%' },
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      },
      cellProps: {
        style: { width: '10%' },
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      }
    }
  }
];

const UsersTable = () => {
  return (
    <div className="border-top border-translucent">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};

export default UsersTable;
